import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import InitialQuestionsPage from './initialQuestionsPage';
import {
  dataCaptureSelectors,
  saveInitialQuestionsForm,
  redirectToCustomerDetailsReview
} from '../../store/dataCapture';
import { INITIAL_INFO, OFFER_CASE_ID, CASE_ID } from '../../utils/constants';
import { changeWindowHref } from '../../utils/redirectUtils';
import { selectors as caseSelector } from '../../infrastructure/cases';

class InitialQuestionsSection extends Component {
  constructor(props) {
    super(props);
    this.onInitialFormSubmit = this.onInitialFormSubmit.bind(this);
  }

  onInitialFormSubmit(values) {
    if (values.accountType === 'Yes' && !this.props.accessToken) {
      changeWindowHref(this.props.idvUrl);
    } else if (this.props.caseId && this.props.isLinkCodeFlow) {
      this.props.redirectToCustomerDetailsReview('', {
        case_id: this.props.caseId,
        linkCodeResume: 'linkResume'
      });
    } else {
      this.props.saveInitialQuestionsForm(values);
    }
  }

  render() {
    const { bankId, brandId, getBusinessData, offer, isLinkCodeFlow, caseId } = this.props;

    return (
      <InitialQuestionsPage
        brandId={brandId}
        bankId={bankId}
        offer={offer}
        caseId={caseId}
        onInitialFormSubmit={this.onInitialFormSubmit}
        isLinkCodeFlow={isLinkCodeFlow}
        getBusinessData={getBusinessData}
      />
    );
  }
}

InitialQuestionsSection.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  saveInitialQuestionsForm: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state),
  caseId:
    selectors.getSingleEntry(state, CASE_ID) || selectors.getSingleEntry(state, OFFER_CASE_ID),
  getBusinessData: dataCaptureSelectors.getBusinessData(state, INITIAL_INFO),
  offer: selectors.getProductName(state),
  idvUrl: selectors.getIDVurl(state),
  accessToken: selectors.accessToken(state),
  isLinkCodeFlow: caseSelector.linkCodeAvailable(state)
});

const actionCreators = {
  saveInitialQuestionsForm,
  redirectToCustomerDetailsReview
};

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InitialQuestionsSection);
